import styled, { css } from 'styled-components';
import { PlaceholderShimmerBackground } from 'utils/fragments';

const primary = css`
    background: ${({ theme }) => theme.purple_1};
    color: ${({ theme }) => theme.gray_7};
    min-width: 9.57em;

    &[disabled],
    &[disabled]:hover {
        background: ${({ theme }) => theme.purple_1};
    }

    &:hover,
    &:focus-visible {
        background-color: ${({ theme }) => theme.purple_2};
    }
`;

const secondary = css`
    background-color: ${({ theme }) => theme.gray_7};
    color: ${({ theme }) => theme.purple_1};
    border-color: ${({ theme }) => theme.gray_5};

    &:hover,
    &:focus-visible {
        background-color: ${({ theme }) => theme.gray_5};
    }
`;

const UntrackedButton = styled.button.attrs(
    ({ type = 'button', intent = 'primary' }) => ({
        type,
        intent,
    }),
)`
    font-weight: ${({ theme }) => theme.fontBold};
    font-family: ${({ theme }) => theme.style_primary};
    font-size: inherit;
    line-height: 1.21em;
    padding: 0.6em 0.86em;
    border-radius: ${({ theme }) => theme.borderRadius_md};
    border: solid 2px transparent;
    min-width: 4em;
    text-align: center;
    text-transform: capitalize;
    display: inline-flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    outline-offset: 4px;

    ${({ intent }) => intent === 'primary' && primary}
    ${({ intent }) => intent === 'secondary' && secondary}
    ${({ fetching }) => fetching && PlaceholderShimmerBackground}

    &[disabled], &[disabled]:hover {
        ${({ fetching }) => fetching && PlaceholderShimmerBackground}
        cursor: ${({ fetching }) => (fetching ? 'wait' : 'not-allowed')};
        opacity: 0.4;
    }
`;

export default UntrackedButton;
